var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy180(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M67,40.8c0-2.9-1.2-5.6-3.1-7.6C62,31.3,59.4,30,56.5,30H56v-6.3c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1V30h-7.7 v-6.3c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1V30h-6.8c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7v19.4v19.4c0,0.3,0.1,0.5,0.3,0.7 c0.2,0.2,0.4,0.3,0.7,0.3h6.8v5.6c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-5.6H54v5.6c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1v-5.6h0.5 c2.9,0,5.5-1.2,7.4-3.1c1.9-1.9,3.1-4.6,3.1-7.6c0-2.9-1.2-5.6-3.1-7.6c-0.9-0.9-1.9-1.6-3-2.1c1.1-0.5,2.1-1.3,3-2.1 C65.8,46.4,67,43.7,67,40.8z M62.5,54c1.5,1.6,2.5,3.7,2.5,6.2c0,2.4-1,4.6-2.5,6.2c-1.5,1.6-3.6,2.5-6,2.5H38.6V51.5h17.9 C58.8,51.5,60.9,52.4,62.5,54z M56.5,49.5H38.6l0-17.4h17.9c2.3,0,4.4,1,6,2.5c1.5,1.6,2.5,3.7,2.5,6.2c0,2.4-1,4.6-2.5,6.2 C60.9,48.5,58.8,49.5,56.5,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M49.6,15.2c-19.3,0-34.9,15.6-34.9,34.9C14.6,69.4,30.3,85,49.6,85c19.3,0,34.9-15.6,34.9-34.9 C84.5,30.8,68.9,15.2,49.6,15.2z M72.9,73.4c-6,6-14.2,9.6-23.3,9.6c-9.1,0-17.3-3.7-23.3-9.6c-6-6-9.6-14.2-9.6-23.3 c0-9.1,3.7-17.3,9.6-23.3c6-6,14.2-9.6,23.3-9.6c9.1,0,17.3,3.7,23.3,9.6c6,6,9.6,14.2,9.6,23.3C82.5,59.2,78.8,67.4,72.9,73.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy180);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-180.2648ea21f48d2744a1f1ae111a62d274.svg";
export { ForwardRef as ReactComponent };